import { defineStore } from 'pinia'

interface TokenInfo {
  token: string
  expirationTime: number
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    currentToken: null as TokenInfo | null,
  }),
  getters: {
    token: (state) => state.currentToken?.token || null,
    tokenExpirationTime: (state) => state.currentToken?.expirationTime || null,
    isTokenValid: (state) => {
      if (!state.currentToken) return false
      return Date.now() < state.currentToken.expirationTime
    },
  },
  actions: {
    setToken(token: string, expirationTime: number) {
      this.currentToken = {
        token,
        expirationTime,
      }
    },
    clearToken() {
      this.currentToken = null
    },
  },
})
